
import { ACTIVE_SESSIONS } from "../constant/actionTypes";

export default (state, action) => {
    if (typeof state == 'undefined') {
        state = [];
    }

    switch (action.type) {
        case ACTIVE_SESSIONS.GET.INITIATE:
            return {isFetching: true};
        case ACTIVE_SESSIONS.GET.SUCCESS:
            return {isFetching: false, data: action.payload};
        case ACTIVE_SESSIONS.GET.ERROR:
            return {isFetching: false, data: action.payload};
        default:
            return state;
    }
};